

import { defineComponent,PropType,ref,Ref,provide,watchEffect,onMounted,computed } from 'vue';
import {UserService} from "@/services/user.service";
import {StatusService} from "@/services/status.service";

export default defineComponent({
   name: "HeaderFile",
   props:{
      
    },
    setup(props,context){

      let statusArray:Ref<string[]>=ref([]);
      const serviceStatus= new StatusService();
      const serviceUser = new UserService();
      let objSearch :Ref<Object> = ref({status:""});

      const fetchStatus = async()=>{statusArray.value= await serviceStatus.getAll(serviceUser.fetch().token);}
      fetchStatus();

      const btnSearch = ()=>{
	console.log("oli");
	context.emit("searchingfile",objSearch.value);
      };
      
      return {statusArray,objSearch,btnSearch};

    }
});

